module.exports = __webpack_public_path__ + "img/phone-black.8fa73d9.svg?v=1791296779994";